import React, { useEffect, useState } from 'react';
import { validateToken, ClientToken } from './utils/tokens';
import LockedScreen from './components/LockedScreen';
import IntakeForm from './components/IntakeForm';

function App() {
  const [clientToken, setClientToken] = useState<ClientToken | null>(null);
  const [checked, setChecked] = useState(false);

  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get('token') || '';

    validateToken(token).then(result => {
      setClientToken(result);
      setChecked(true);
    });
  }, []);

  // Show spinner while we check the token with the server
  if (!checked) {
    return (
      <div className="min-h-screen bg-dark-900 flex items-center justify-center">
        <div className="w-6 h-6 border border-dark-500 border-t-lime-400 rounded-full animate-spin" />
      </div>
    );
  }

  if (!clientToken) {
    return <LockedScreen />;
  }

  return <IntakeForm clientToken={clientToken} />;
}

export default App;
